import { gql } from '@apollo/client';
import { FRAGMENT_ACCESS_GROUP } from './fragment.accessGroup';

export const FETCH_ALL_ACCESS_GROUPS = gql`
    ${FRAGMENT_ACCESS_GROUP}
    query fetchAllAccessGroups {
        system {
            accessGroups {
                ...accessGroup
            }
            companies {
                id
                accessGroups {
                    ...accessGroup
                }
                facilities {
                    id
                    accessGroups {
                        ...accessGroup
                    }
                }
            }
        }
    }
`;
